import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const usePhysicianWidgetSettings = (physicianUserIds, shouldLoad = true) => {
  const dispatch = useDispatch();
  const { load } = dispatch.physicianWidgetSettings;
  const isLoading = useSelector(({ loading }) => loading.effects.physicianWidgetSettings.load);
  const data = useSelector(state => state.physicianWidgetSettings);

  useEffect(() => {
    if (physicianUserIds.length && shouldLoad) {
      load({ physicianUserIds });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, JSON.stringify(physicianUserIds)]);

  return {
    widgetSettings: Object.keys(data)
      .filter(key => physicianUserIds.includes(key))
      .reduce((obj, key) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = data[key].widgetSettings;
        return obj;
      }, {}),
    isLoading,
  };
};

export default usePhysicianWidgetSettings;
